import { breakpoints } from '@/config/breakpoints';
import { styled } from 'styled-components';

export const Wrapper = styled.div<{
  fullWidth: boolean;
  isSocialPost: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  max-width: ${(props) => (props.fullWidth ? '' : '1140px')};
  width: 100%;
  /* padding: 36px 40px;
  max-height: ${(props) => (props.isSocialPost ? '' : '90px')};; */
  padding: 20px 40px;
  /* max-width: 1128px;
  margin: 0 auto; */
  @media screen and (max-width: ${breakpoints.lg}) {
    padding: 80px 0 40px;
    /* border-top: 1px solid #1a202f; */
  }
  @media screen and (max-width: ${breakpoints.lg}) {
    flex-direction: column;
    /* padding:  ${(props) =>
      props.isSocialPost ? '24px 16px 40px' : '24px 0 16px'}; */
    padding: 32px 16px;
    gap: 24px;
    background: ${(props) => (props.isSocialPost ? 'transparent' : '')};
  }
`;

export const ImgBg = styled.img`
  display: none;
  @media screen and (max-width: ${breakpoints.md}) {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
  }
`;

export const TxtBy = styled.span`
  color: white;
  font-size: 12px;
  font-family: 'Inter';
  line-height: 18px;
  letter-spacing: 0.15px;
`;

export const FrameInfo = styled.div<{ isSocialPost: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 27px;
  justify-content: flex-end;
  z-index: 1;
  @media screen and (max-width: ${breakpoints.md}) {
    text-align: left;
    /* flex-direction: column; */
    gap: 28px;
    justify-content: center;
    width: 100%;
    /* margin-top: ${(props) => (props.isSocialPost ? 0 : '16px')}; */
    /* margin-top: 16px; */
  }
`;

export const ItemInfo = styled.span`
  color: #fff;
  font-size: 12px;
  font-family: 'Inter';
  /* margin-right: 25px; */
  cursor: pointer;
  @media screen and (max-width: ${breakpoints.md}) {
    /* flex: 1; */

    /* margin-right: 0; */
    text-align: center;
  }
`;
